import $ from 'domtastic'
import { TweenMax as TM } from 'gsap/all'

import { clamp } from '../utils/utils'

import Menu from './blocks/Menu'
import Dropdown from './blocks/Dropdown'
import CookiesNotice from './blocks/CookiesNotice'
import Tabs from './blocks/Tabs'
import Scrollbar from './blocks/Scrollbar'
import DataTable from './blocks/DataTable'
import TabSwitch from './blocks/TabSwitch'
import RadioToggle from './blocks/RadioToggle'
import CheckoutDeliveryRadioRefresh from './blocks/CheckoutDeliveryRadioRefresh'
import HeaderCart from './blocks/HeaderCart'
import DeleteResourceBtn from './blocks/DeleteResourceBtn'
import DamLinkBtn from './blocks/DamLinkBtn'
import SubmitFormLink from './blocks/SubmitFormLink'
import Select from './blocks/Select'


const compsMap = {
    Menu,
    Dropdown,
    CookiesNotice,
    Tabs,
    DataTable,
    Scrollbar,
    TabSwitch,
    RadioToggle,
    CheckoutDeliveryRadioRefresh,
    HeaderCart,
    DeleteResourceBtn,
    DamLinkBtn,
    SubmitFormLink,
    Select,
}




/* LAYOUT
----------------------------------------------------------------------------------------------------*/

export default class Layout {

    constructor() {
        this.$els = {
            html   : $('html'),
            body   : $('body'),
            header : $('#header'),

            grid     : $('#grid'),
            colSizer : $('.grid-sizer.col-1'),
            gutSizer : $('.grid-sizer.gut-1'),
        }


        this.comps = {}


        this.dragging      = false
        this.scrollBlocked = !APP.Browser.cookiesAccepted
        this.scrollTimer   = null
        this.resizeTimer   = null
        this.activeEvent   = APP.Browser.supports.passive ? { passive: false } : false


        this.getLayoutValues()
        this.getDocValues()


        this.cookiesHandler       = (e) => { this.onCookiesAccepted(e) }
        this.pageChangeHandler    = () => { this.onPageWillChange() }
        this.pageChangeEndHandler = (e) => { this.onPageChangeEnd(e) }
        this.resizeHandler        = () => { this.onResize() }
        this.touchmoveHandler     = (e) => { this.onPointerMove(e, true) }
        this.wheelHandler         = (e) => { this.onWheel(e) }


        this.bindEvents()
        setTimeout(() => this.initComps(), 0)
    }


    bindEvents() {
        // Nav events
        $(document).on('cookiesAccepted', this.cookiesHandler)
        $(document).on('pageWillChange', this.pageChangeHandler)
        $(document).on('pageChangeEnd', this.pageChangeEndHandler)


        // Window events
        $(window).on('resize', this.resizeHandler)


        // Input events
        $(document).on('touchend', () => { this.dragging = false })
        document.addEventListener('touchmove', this.touchmoveHandler, this.activeEvent)
        document.addEventListener('wheel', this.wheelHandler, this.activeEvent)

        // DISABLED ON 2023-10-16
        // // @TEMP (slicing only)
        // $('input, textarea').on('keyup change', (e) => {
        //     e.target.setAttribute('value', e.target.value)
        // })


        // Components events
        $(document).on('menuToggled', (e) => { this.onMenuToggled(e) })


        // Toggle Grid (dev purposes only)
        if ($('#grid-wrapper').length) {
            this.initVisualGrid()
        }
    }


    initComps() {
        $('[data-component]').each((el) => {
            const $el = $(el)

            const compName = $el.attr('data-component').replace(/-|\s/g, '')
            const compsList = compName.split(',')

            $el.removeAttr('data-component')

            compsList.forEach((c) => {
                if (compsMap[c]) {
                    if (!this.comps[c]) {
                        this.comps[c] = []
                    }

                    this.comps[c].push(new compsMap[c]($el, this.namespace, this))
                } else {
                    console.warn(`Component [${c}] not registered in Layout.`)
                }
            })
        })
    }


    initVisualGrid() {
        $(document).on('keydown', (e) => {
            const tag = document.activeElement.tagName.toLowerCase()

            if (e.key === 'g' && tag !== 'input' && tag !== 'textarea' && tag !== 'select') {
                e.preventDefault()
                this.$els.body.toggleClass('grid-visible')
            }
        })
    }




    /* Handlers
    ---------------------------------------------------------*/

    onResize(force) {
        this.resizing = true

        this.getLayoutValues()
        this.getDocValues()


        // Resize timer
        clearTimeout(this.resizeTimer)
        $('body').addClass('resizing')

        this.resizeTimer = setTimeout(() => {
            this.resizing = false

            $('body').removeClass('resizing')

            if (!this.falseResize && !force) {
                $(document).trigger('layoutChange')
            }
        }, 150)
    }


    onPointerMove(e, isTouch) {
        if (isTouch) {
            this.dragging = true

            if (this.scrollBlocked) e.preventDefault()
        }
    }


    onWheel(e) {
        if (this.scrollBlocked) e.preventDefault()
    }


    onMenuToggled(e) {
        this.scrollBlocked = e.detail.open
    }




    /* Actions
    ---------------------------------------------------------*/




    /* Values
    ---------------------------------------------------------*/

    getDocValues() {
        this.docHeight    = document.body.clientHeight
        this.pixelDensity = clamp(window.devicePixelRatio, 1, 2)
    }


    getLayoutValues() {
        if (this.W) this.prevW = this.W

        this.W = document.body.clientWidth
        this.H = window.innerHeight

        this.scrollbarW   = window.innerWidth - this.W
        this.widthChanged = this.prevW !== this.W
        this.falseResize  = (APP.Browser.isMobile && !this.widthChanged)

        if (!this.baseH || !this.falseResize) this.baseH = window.innerHeight


        // MQ
        this.isDesktop = window.matchMedia('(min-width: 961px)').matches
        this.isTablet  = window.matchMedia('(max-width: 960px) and (min-width: 768px)').matches
        this.isMobile  = window.matchMedia('(max-width: 767px)').matches


        // Elements sizes
        this.headerH = this.$els.header[0].offsetHeight
        this.vpH     = (APP.Browser.isMobile) ? this.baseH : this.H

        this.gridWidth   = this.$els.grid[0].getBoundingClientRect().width
        this.colWidth    = this.$els.colSizer[0].getBoundingClientRect().width
        this.gutWidth    = this.$els.gutSizer[0].getBoundingClientRect().width
        this.marginWidth = (this.W - this.gridWidth) / 2


        // CSS Custom Props
        TM.set(this.$els.html, {
            '--vh'   : `${this.vpH / 100}px`,
            '--vw'   : `${this.W / 100}px`,
            '--vmin' : `${Math.min(this.W / 100, this.vpH / 100)}px`,
            '--vmax' : `${Math.max(this.W / 100, this.vpH / 100)}px`,

            '--vpW'  : `${this.W}px`,
            '--vpH'  : `${this.vpH}px`,
            '--sbW'  : `${this.scrollbarW}px`,

            '--col'    : `${this.colWidth}px`,
            '--gut'    : `${this.gutWidth}px`,
            '--margin' : `${this.marginWidth}px`,
        })


        this.$els.html.addClass('variables')
        $(document).trigger('layoutVariablesChanged')
    }

}



